<template lang="html">
  <div>
    <div class="breadCrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ $t('message.function') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('message.functionAdd') }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="verifone-panel">
      <div class="add-container">
        <div class="add-title">
          <span>{{ $t('message.functionConfigurationManagement') }}</span>
        </div>
        <div class="item-container">
          <el-form>
            <template>
            <el-form-item >
            <span style="width:100px;text-align:left;display:inline-block;font-size:15px;">{{ $t('message.groupName') }}</span>&#160;&#160;
              <el-select value-key="groupName" v-model="id" @change="handleChange" style="width:230px"  filterable>
                <el-option v-for="item in resellerList" :key="item.groupName" :label="item.groupName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item >
            <span style="width:100px;text-align:left;display:inline-block;font-size:15px;">{{ $t('message.functionType') }}</span>&#160;&#160;
             <el-select v-model="functionType" style="width:230px" >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            </template>
          </el-form>
          <br />
          <br />
          <div class="submit-container">
            <el-button class="verifone-btn" type="primary" plain icon="el-icon-back" @click="callBack">{{ $t('message.back') }}</el-button>
            <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="submitFrom()">{{ $t('message.submit') }}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Loading } from 'element-ui';
export default {
  data() {
    return {
      loginName: '',
      password: '',
      reconfirm: '',
      email: '',
      cellNumber: '',
      telephoneNo: '',
      token: '',
      resetFlag: false,
      id:'',
      groupName: '',
      resellerList: [],
      addresseedynamicTags: [],
      inputVisible: false,
      addressee: '',
      ccpersondynamicTags: [],
      ccpersonVisible: false,
      CCperson: '',
      sendDate: '',
      resellerId: '',
      functionType:'',
      startTime:'',
      endTime:'',
      emailCheck: this.$t('message.emailCheck'),
      deleteSuccess: this.$t('message.deleteSuccess'),
      submitSuccess: this.$t('message.submitSuccess'),
       options: [{
                value: '0',
                label: this.$t('message.locationService')
              }],
    };
  },
  mounted() {
    this.init();
    this.queryGroupName();
  },
  methods: {
    init() {
      this.token = new Date().getTime();
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleChange(val) {
      var obj = {};
      obj = this.resellerList.find(function(item) {
        return item.groupName === val;
         console.log("aaa+"+obj)
      });

    },
    callBack() {
      this.$router.replace('/functionList');
    },

    submitFrom() {
      let loadingInstance = Loading.service({
        lock: true,
        text: 'Loading...',
        background: 'rgba(255, 255, 255, 0.5)'
      });
      const that = this;

      //验证组名
      if (this.id == '') {
        this.$message({
          message: this.$t('message.groupNameCheck'),
          type: 'warning',
          duration: '3000',
          showClose: true
        });
        loadingInstance.close();
        return;
      }
      //验证功能设置
      if(this.functionType ==''){
        this.$message({
          message: this.$t('message.functionConfigCheck'),
          type: 'warning',
          duration: '3000',
          showClose: true
        });
        loadingInstance.close();
        return;
      }

      let param = {
        groupId   : this.id,
        groupName : this.groupName,
        functionType : this.functionType,
        token: this.token
      };
      this.$axios({
        method: 'post',
        url: '/marketplace/function/groupFunctionAdd',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') },
        data: param
      }).then(response => {
          if (response.data.code !="00") {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000'
            });
            this.token = new Date().getTime();
            loadingInstance.close();
            return;
          } else {
            this.$message({
              type: 'success',
              message: that.submitSuccess,
              duration: '3000'
            });
            loadingInstance.close();
            this.$router.replace('/functionList');
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //查询组名称
    queryGroupName() {
      this.$axios({
        method: 'post',
        url: '/marketplace/group/AllGroupList',
        headers: { 'Accept-Language': sessionStorage.getItem('acceptLanguage') }
      })
        .then(response => {
          if (response.data.code != "00") {
            this.$message({
              type: 'error',
              message: response.data.desc,
              duration: '3000',
              showClose: true
            });
            return;
          } else {
            this.resellerList = response.data.data;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style lang="css" scoped="scope">
.appManagement-container {
	overflow: hidden;
	display: flex;
	display: -webkit-flex;
	align-items: center;
	width: 100%;
}
.appManagement-table {
	width:100%;
	padding:10px 30px;
}
.appManagement-table-main {
	padding: 20px;
	background-color: #fff;
}
.appManagement-search .el-input__inner {
	border-radius: 20px;
}
/* .search-container {
padding-right: 100px;
} */
.appManagement-search {
	width: 400px;
	border-radius: 20px;
	margin-right: 10px;
}
.edit-item {
	justify-content: flex-start
}
.edit-item >span {
	text-align: right;
	margin-right: 15px;
	width:120px!important;
}
.addAdminInput {
	width:200px
}
.addApp-btn {
	background: #58D56D;
	color: #fff;
}
.breadCrumb-container {
	width: 100%;
}
.delete-btn {
	width: 20px;
	height: 20px;
}
.redStar {
	color: red;
	font-size: 20px;
	font-weight: bold;
	margin-top: 5px;
	margin-right: 10px;
	position: relative;
	top: 6px;
}
.table-border {
	border: 1px solid #e7e7e7;
	border-radius: 10px;
	overflow: hidden;
}
.verifone-panel {
	padding: 20px;
}
.item-container {
	margin-left: 10vw;
	width: 45vw;
}
.separationLine {
	border-bottom: 1px dashed #999;
	margin: 30px 0
}
.verifone-panel {
	max-height: 85vh;
	overflow-y: scroll;
}
.submit-container {
	padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/function/FunctionAdd.vue